export default __webpack_public_path__ + "static/media/Icon feather-delete.a0d2a3f5.svg";